import React from 'react';
import { PdfHuchaCardContainer2 } from '../../../ui/pdf-hucha-card-container';
import { PdfHuchaStandardCardC2 } from './pdf-hucha-standard-card-c2';
import { PdfHuchaStandardCardC3 } from './pdf-hucha-standard-card-c3';

export const PdfHuchaStandardCard: React.FC<{
	dineroHucha: string;
}> = ({ dineroHucha }) => {
	return (
		<PdfHuchaCardContainer2>
			<PdfHuchaStandardCardC2 />
			<PdfHuchaStandardCardC3 dineroHucha={dineroHucha} />
		</PdfHuchaCardContainer2>
	);
};
